module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/2@2x_babc631eb47d2c252365aa76fc956807.png";